import { takeLatest, put, call } from 'redux-saga/effects';
//  SagaReturnType is a type, so it comes in as one. Imported as a value it trips
//  import/named, which cannot see a type-only export — the older sagas in this folder
//  still carry that error; CI only lints files a PR touches, so it goes unreported.
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';

const {
  REQUEST_GET_PATIENT_DOCUMENTS,
  SUCCESS_GET_PATIENT_DOCUMENTS,
  FAILURE_GET_PATIENT_DOCUMENTS,
  LOADING_GET_PATIENT_DOCUMENTS,
} = documentBundleActions;

function* getPatientDocuments(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_PATIENT_DOCUMENTS });
    const response = yield call(
      documentBundleService.getPatientDocuments,
      action.patientUuid,
      action.params
    );
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_PATIENT_DOCUMENTS, payload: response.data?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_PATIENT_DOCUMENTS, payload: error });
  }
}

function* getPatientDocumentsSaga() {
  yield takeLatest(REQUEST_GET_PATIENT_DOCUMENTS, getPatientDocuments);
}

export default getPatientDocumentsSaga;
export { getPatientDocuments };
